<template>
  <!-- Blog Section -->
  <section class="blog-section news-section pt-0">
    <div class="container">
      <!-- Heading title-->
      <div class="section-heading" data-aos="fade-down">
        <h2>أخبار ورؤى لك</h2>
        <p>تقدم هذه التدوينة رؤى قيّمة حول الفوائد</p>
      </div>
      <!-- /Heading title -->

      <div class="row">
        <div
          v-for="blog in visibleBlogs"
          :key="blog.id"
          class="col-lg-4 col-md-6 d-lg-flex"
        >
          <div class="blog grid-blog">
            <div class="blog-image">
              <router-link :to="`/blog/blog-details/${blog.id}`">
                <img class="img-fluid" :src="blog.image" alt="صورة المقال" />
              </router-link>
            </div>
            <div class="blog-content">
              <p class="blog-category">
                <a href="javascript:void(0)"><span>أخبار</span></a>
              </p>
              <h3 class="blog-title">
                <router-link :to="`/blog/blog-details/${blog.id}`">
                  {{ blog.title }}
                </router-link>
              </h3>
              <p class="blog-description">{{ blog.description }}</p>
              <ul class="meta-item mb-0">
                <li>
                  <div class="post-author">
                    <div class="post-author-img">
                      <img src="@/assets/img/profiles/avatar-04.jpg" alt="الكاتب" />
                    </div>
                    <a href="javascript:void(0)"> <span>فريقنا</span></a>
                  </div>
                </li>
                <li class="date-icon">
                  <i class="fa-solid fa-calendar-days"></i>
                  <span>{{ blog.created_at }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Show More button -->
      <div 
        class="view-all text-center aos-init aos-animate mt-4" 
        data-aos="fade-down" 
        v-if="blogStore.blogs.length > visibleCount"
      >
        <button 
          class="btn btn-view d-inline-flex align-items-center btn-view-car"
          @click="visibleCount += 3"
        >
          عرض المزيد <span><i class="feather-arrow-right ms-2"></i></span>
        </button>
      </div>
    </div>
  </section>
  <!-- /Blog Section -->
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useBlogStore } from "@/stores/blog-store";

const blogStore = useBlogStore();

const visibleCount = ref(6) // أول 6 مقالات

const visibleBlogs = computed(() => blogStore.blogs.slice(0, visibleCount.value))

// reset لما يتغيروا المقالات
watch(
  () => blogStore.blogs,
  () => {
    visibleCount.value = 6
  }
)

onMounted(() => {
  blogStore.fetchBlogs();
});
</script>

<style scoped>
.blog-section{
  margin-top: 40px;
}
.section-heading h2 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, #28a745, #20c997);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: center;
}
.blog-image img {
  width: 100%;      
  height: 250px;     
  object-fit: cover;
  border-radius: 8px; 
}
</style>
